import React, {useEffect, useState} from 'react';
import {COUNTDOWN_LABELS, WEDDING_DATE_START} from '../constants/wedding';
import {FaArrowUp} from 'react-icons/fa6';

interface CountdownTime {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

const Footer: React.FC = () => {
    const [timeLeft, setTimeLeft] = useState<CountdownTime>({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });
    const [showScroll, setShowScroll] = useState(false);

    const scrollTop = () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    };

    useEffect(() => {
        const checkScrollTop = () => {
            if (window.scrollY > 400) {
                setShowScroll(true);
            } else {
                setShowScroll(false);
            }
        };

        window.addEventListener('scroll', checkScrollTop);
        return () => window.removeEventListener('scroll', checkScrollTop);
    }, []);

    useEffect(() => {
        const calculateTimeLeft = (): CountdownTime => {
            const now = new Date().getTime();
            const weddingTime = WEDDING_DATE_START.getTime();
            const difference = weddingTime - now;

            if (difference > 0) {
                return {
                    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                    minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
                    seconds: Math.floor((difference % (1000 * 60)) / 1000)
                };
            }

            return {days: 0, hours: 0, minutes: 0, seconds: 0};
        };

        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        // Calculate initial time
        setTimeLeft(calculateTimeLeft());

        return () => clearInterval(timer);
    }, []);

    const CountdownUnit: React.FC<{ value: number; label: string }> = ({value, label}) => (
        <div className="flex flex-col items-center mx-4 sm:mx-6 md:mx-8">
            <div className="font-elza-countdown text-[60pt] md:text-[125pt] text-white mb-2">
                {value.toString().padStart(2, '0')}
                {label !== COUNTDOWN_LABELS.seconds ? ' •' : ''}
            </div>
            <div className="text-sm sm:text-base md:text-lg text-gray-300 uppercase tracking-wider mr-8">
                {label}
            </div>
        </div>
    );

    return (
        <footer className="pb-20 bg-[url(assets/images/Footer.jpg)] bg-cover md:bg-center bg-[left_-150px_top_0px] bg-black/40 bg-blend-multiply min-h-[80dvh] text-white text-center flex flex-col items-center justify-center">
            <div className="text-[20pt] font-[10]">
                Faltan:
            </div>
            <div className="container mx-auto px-4">
                <div className="flex justify-center items-center flex-wrap mb-8">
                    <CountdownUnit value={timeLeft.days} label={COUNTDOWN_LABELS.days}/>
                    <CountdownUnit value={timeLeft.hours} label={COUNTDOWN_LABELS.hours}/>
                    <CountdownUnit value={timeLeft.minutes} label={COUNTDOWN_LABELS.minutes}/>
                    <CountdownUnit value={timeLeft.seconds} label={COUNTDOWN_LABELS.seconds}/>
                </div>
            </div>
            {showScroll && (
                <button
                    onClick={scrollTop}
                    className="fixed bottom-8 right-8 bg-black/60 hover:bg-black/80 text-white p-3 rounded-full transition-all duration-300 cursor-pointer"
                    aria-label="Scroll to top"
                >
                    {FaArrowUp({size:20})}
                </button>
            )}
            <div className="absolute bottom-4 left-4">
                <div className="h-20 bg-[url(assets/objects/Firmas.png)] bg-contain bg-no-repeat bg-center select-none pointer-events-none"/>
                <div className="text-left text-[10pt]">
                    Hecho, con mucho amor, <br/> por Eli & Lalo.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
